import { Check } from "lucide-react";
import { Button } from "../ui/button";

const plans = [
  {
    name: "Independiente",
    desc: "Para fisioterapeutas que trabajan solos.",
    price: "$499",
    period: "/mes MXN",
    features: [
      "1 fisioterapeuta",
      "Pacientes ilimitados",
      "Agenda completa",
      "Expediente clinico digital",
      "Episodios de atencion",
      "Portal del paciente",
      "Recordatorios por email",
    ],
    cta: "Iniciar prueba gratis",
    highlight: false,
  },
  {
    name: "Clinica",
    desc: "Para clinicas con equipo de terapeutas.",
    price: "$999",
    period: "/mes MXN",
    features: [
      "Hasta 5 fisioterapeutas",
      "Todo lo del plan Independiente",
      "Gestion multi-usuario",
      "Dashboard operativo avanzado",
      "Reportes de productividad",
      "Control de pagos completo",
      "Soporte prioritario",
    ],
    cta: "Iniciar prueba gratis",
    highlight: true,
    badge: "Popular",
  },
];

export const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-24 md:py-32 bg-white relative"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-semibold text-emerald-600 uppercase tracking-widest mb-3">
            Precios
          </p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-slate-900 tracking-tight mb-4">
            Precios transparentes
          </h2>
          <p className="text-base md:text-lg text-slate-500 leading-relaxed">
            Sin contratos forzosos. Cancele cuando quiera. 14 dias de prueba gratis.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {plans.map((plan, i) => (
            <div
              key={i}
              data-testid={`pricing-card-${i}`}
              className={`relative rounded-2xl p-8 ${
                plan.highlight
                  ? "pricing-highlight bg-white border-2 border-emerald-500 shadow-xl shadow-emerald-500/10"
                  : "bg-white border border-slate-200 shadow-sm"
              }`}
            >
              {plan.badge && (
                <span className="absolute -top-3 left-8 bg-emerald-500 text-white text-xs font-bold px-4 py-1 rounded-full">
                  {plan.badge}
                </span>
              )}

              <h3 className="font-heading font-bold text-xl text-slate-800 mb-1">
                {plan.name}
              </h3>
              <p className="text-sm text-slate-500 mb-6">{plan.desc}</p>

              <div className="flex items-baseline gap-1 mb-8">
                <span className="font-heading font-bold text-4xl text-slate-900">
                  {plan.price}
                </span>
                <span className="text-sm text-slate-400">{plan.period}</span>
              </div>

              <Button
                data-testid={`pricing-cta-${i}`}
                className={`w-full rounded-full py-6 font-semibold text-base mb-8 transition-shadow duration-200 ${
                  plan.highlight
                    ? "bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/40"
                    : "bg-slate-900 hover:bg-slate-800 text-white"
                }`}
              >
                {plan.cta}
              </Button>

              <ul className="space-y-3">
                {plan.features.map((feat, j) => (
                  <li key={j} className="flex items-center gap-3">
                    <div
                      className={`w-5 h-5 rounded-md flex items-center justify-center ${
                        plan.highlight ? "bg-emerald-100" : "bg-slate-100"
                      }`}
                    >
                      <Check
                        className={`w-3 h-3 ${
                          plan.highlight ? "text-emerald-600" : "text-slate-600"
                        }`}
                      />
                    </div>
                    <span className="text-sm text-slate-600">{feat}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
